import { regexpSubwayMoverTypeExist } from '../../constants/pikPlus';

export const formatSubwayTime = (time?: string | null) => time && time.replace(regexpSubwayMoverTypeExist, '');
